export default Object.freeze({
  ACTIVE: 'active',
  ARCHIVED: 'archived',
});
